module.exports = __webpack_public_path__ + "static/media/coinkite.b6098277.svg";